import React, { useMemo } from "react"
import ReactSelect from "react-select"
import useT from "utils/hooks/useT"

export default function TaskStatePicker({ required, disabled, value, onChange, menuPlacement }) {
  const { t } = useT("common")
  const taskStateOptions = useMemo(
    () => [
      { label: <>{t("backlog")}</>, value: "BACKLOG" },
      { label: <>{t("toDo")}</>, value: "TODO" },
      { label: <>{t("planned")}</>, value: "PLANNED" },
      { label: <>{t("finished")}</>, value: "FINISHED" },
    ],
    [t]
  )
  const taskStateValue = taskStateOptions.find((item) => item.value === value)
  if (required && !taskStateValue) {
    throw new Error("TaskStatePicker received an invalid value")
  }
  return (
    <ReactSelect
      className="TaskStatePicker"
      classNamePrefix="TaskStatePicker"
      placeholder={t("selectState")}
      isClearable={false}
      isDisabled={disabled}
      options={taskStateOptions}
      onChange={({ value }) => onChange(value)}
      value={taskStateValue}
      menuPosition="absolute"
      menuPlacement={menuPlacement}
    />
  )
}
